{
  "BlockType": {
    "article__attachment": "Vedlegg",
    "article__audio": "Lyd",
    "article__bodytext": "Tekst",
    "article__byline": "Byline",
    "article__card": "Kort/Faktakort",
    "article__dateline": "Metadata/datolinje",
    "article__media": "Bilder",
    "article__module": "Banner i innholdseksjon (v1.0)",
    "article__openinghours": "Åpningstider (v1.0)",
    "article__person": "Person (v1.0)",
    "article__program": "Program",
    "article__quote": "Sitat",
    "article__references": "Referanser/kilder",
    "article__relations": "Lenkeliste",
    "article__sharing": "Deleknapper (v1.0)",
    "article__table": "Tabell",
    "article__title": "Overskrift og ingress",
    "article__video": "Video",
    "calendar": "Kalender (v1.0)",
    "calendar__navigator": "Tidsnavigator (v1.0)",
    "card": "Kort/Faktakort",
    "cardSearch": "Kortmodul",
    "digitaltMuseum": "DigitaltMuseum (v1.0)",
    "dm_auto": "Digitalt Museum (automatisk)",
    "dm_filter_search": "Digitalt Museum - Utvidet m/ filter",
    "dm_manual": "Digitalt Museum (manuell)",
    "dm_school": "Digitalt Museum - Skole",
    "dm_single": "Digitalt Museum (enkeltobjekt)",
    "employees_auto": "Ansatte (automatisk)",
    "employees_manual": "Ansatte (manuell)",
    "events_auto": "Arrangementer (automatisk)",
    "events_manual": "Arrangementer (manuell)",
    "flexible": "Widget",
    "form": "Skjema",
    "frontpage__module": "Banner",
    "kp": "KulturPunkt",
    "kp_owner": "KulturPunkt (museum)",
    "kulturpunkt": "KulturPunkt (v1.0)",
    "map": "Kart (v1.0)",
    "map_v2": "Kart",
    "member": "Medlemsdata (BPM)",
    "page_list_auto": "Automatisk sideutlisting",
    "page_list_manual": "Manuell sideutlisting",
    "productstatus": "Salgstall (BPM)",
    "search": "Søkeresultat (v1.0)",
    "ticket": "Onlinebillett (BPM)",
    "ticket_validation": "Billettscan (BPM)",
    "timeline": "Tidslinje (v1.0)"
  },
  "DMContentType": {
    "Architecture": "Arkitektur",
    "Artdesign": "Kunst/Design",
    "Article": "Artikkel",
    "Audio": "Lydklipp",
    "Building": "Bygning",
    "Construction": "Konstruksjon",
    "Event": "Hendelse",
    "Exhibition": "Utstilling",
    "Fineart": "Billedkunst",
    "Folder": "Mappe",
    "Investigation": "Undersøkelse",
    "Media": "Media",
    "Museum": "Museum",
    "NavalVessel": "Marinefartøy",
    "Organization": "Organisasjon",
    "Person": "Person",
    "Photograph": "Fotografi",
    "School": "Skole (alle)",
    "school_digital": "Skole (digitalt)",
    "school_physical": "Skole (besøk)",
    "Story": "Fortelling",
    "Thing": "Gjenstand",
    "TimePeriod": "Tidsperiode",
    "Video": "Video",
    "Virtual": "Virtuell opplevelse"
  },
  "DMSortTypes": {
    "artifact.ingress.title": "Tittel",
    "artifact.publishedDate": "Publiseringsdato",
    "artifact.updatedDate": "Dato sist oppdatert",
    "relevance": "Relevanse",
    "score": "Relevanse"
  },
  "Draggable": {
    "DropHereToAbort": "Slipp her for å avbryte",
    "MoveHere": "Flytt hit"
  },
  "FilterLabel": "Filtrer listevisningen",
  "FilterOptions": {
    "created_by_id": "Opplastet av meg",
    "missing_alt": "Mangler alternativ tekst",
    "none": "Ingen filter"
  },
  "IntroSection": {
    "about": "Scrollytell-seksjon brukes for enkle budskap over skiftende bakgrunner (mediaelement eller bakgrunnsfarge (skin)). Skiftende bakgrunner oppnås ved minst to påfølgende scrollytell-seksjoner.",
    "limitations": "Dette er en scrollytell-seksjon hvor man kan legge innbakgrunnsmedia/farge. Bakgrunnsmedia legges inn under seksjonsinnstillinger og kan da være med å fortelle historien sammen med enkle budskap (gjerne tekst) som kan legges i forgrunnen via modulene på vanlig måte. Skiftende bakgrunner oppnås ved scrolling og krever minst to påfølgende scrollytell-seksjoner. Bakgrunnsmedia kan/bør påføres filtre for kontrast og lesbarhet. "
  },
  "KulturioSchemaTypes": {
    "2": "KulturPunkt",
    "12": "Presentasjon",
    "13": "Kioskvisning",
    "14": "Kioskenhet",
    "32": "Rebus"
  },
  "Languages": {
    "da": "Dansk",
    "de": "Tysk",
    "en": "Engelsk",
    "es": "Spansk",
    "fr": "Fransk",
    "it": "Italiensk",
    "ja": "Japansk",
    "ko": "Koreansk",
    "nl": "Nederlandsk",
    "nn": "Norsk (nynorsk)",
    "no": "Norsk (bokmål)",
    "pl": "Polsk",
    "ru": "Russisk",
    "se": "Nordsamisk",
    "sv": "Svensk",
    "zh": "Kinesisk"
  },
  "MainCategory": {
    "": "Ingen kategori",
    "current_affairs": "Aktuelt",
    "event": "Arrangement",
    "exhibition": "Utstilling",
    "information": "Informasjon",
    "knowledge": "Kunnskap",
    "museum": "Museum/besøkssted",
    "system": "System"
  },
  "MainLanguageSite": "Nettstedets hovedspråk",
  "MediaLicense": {
    "Description": {
      "AC 1": "Denne lisensen tillater ingen bruk uten skaperens eksplisitte tillatelse.",
      "CC by": "Denne lisensen tillater gjenbrukere å distribuere, remixe, endre og bygge videre på materialet i hvilket som helst medium eller format, så lenge korrekt kreditering gis den opprinnelige skaperen. Lisensen tillater kommersiell bruk.",
      "CC by-nc": "Denne lisensen tillater gjenbrukere å distribuere, remixe, endre og bygge videre på materialet i hvilket som helst medium eller format, men bare for ikke-kommersiell bruk, og så lenge korrekt kreditering gis den opprinnelige skaperen.",
      "CC by-nc-nd": "Denne lisensen tillater gjenbrukere å kopiere og distribuere materialet i hvilket som helst medium eller format, men bare i uendret tilstand for ikke-kommersiell bruk, og så lenge korrekt kreditering gis den opprinnelige skaperen.",
      "CC by-nc-sa": "Denne lisensen tillater gjenbrukere å distribuere, remixe, endre og bygge videre på materialet i hvilket som helst medium eller format, men bare for ikke-kommersiell bruk, og så lenge korrekt kreditering gis den opprinnelige skaperen. Dersom du remixer, tilpasser eller bygger videre på materialet, må du lisensiere det modifiserte materialet på tilsvarende måte som originalverket.",
      "CC by-nd": "Denne lisensen tillater gjenbrukere å kopiere og distribuere materialet i hvilket som helst medium eller format, men bare i uendret tilstand, og så lenge korrekt kreditering gis den opprinnelige skaperen. Lisensen tillater kommersiell bruk.",
      "CC by-sa": "Denne lisensen tillater gjenbrukere å distribuere, remixe, endre og bygge videre på materialet i hvilket som helst medium eller format, så lenge korrekt kreditering gis den opprinnelige skaperen. Lisensen tillater kommersiell bruk. Dersom du remixer, tilpasser eller bygger videre på materialet, må du lisensiere det modifiserte materialet på tilsvarende måte som originalverket.",
      "CC pdm": "Denne lisensen tillater gjenbrukere å distribuere, remixe, endre og bygge videre på materialet i hvilket som helst medium eller format, uten restriksjoner."
    },
    "FreeReuse": "Fri gjenbruk",
    "Label": {
      "": "Ingen lisens valgt",
      "AC 1": "Rettighetsbelagt (AC 1)",
      "CC by": "Kun navngivelse (BY)",
      "CC by-nc": "Navngivelse + Ikke-kommersiell (BY-NC)",
      "CC by-nc-nd": "Navngivelse + Ikke-kommersiell + Ingen bearbeidelse (BY-NC-ND)",
      "CC by-nc-sa": "Navngivelse + Del på samme vilkår (BY-SA)",
      "CC by-nd": "Navngivelse + Ingen bearbeidelse (BY-ND)",
      "CC by-sa": "Navngivelse + Del på samme vilkår (BY-SA)",
      "CC pdm": "Falt i det fri (PDM)"
    },
    "NoReuse": "Ingen gjenbruk",
    "RestrictedReuse": "Begrenset gjenbruk"
  },
  "MediaResourceType": {
    "asset": "Ressurser",
    "audio": "Lyd",
    "card": "Kort",
    "document": "Dokumenter",
    "form": "Skjemaer",
    "gif": "Animasjoner",
    "image": "Bilder",
    "location": "Steder",
    "page": "Sider",
    "person": "Personer",
    "video": "Videoer"
  },
  "SaveType": {
    "delete_draft": "Slett utkast",
    "save": "$t(common:save)",
    "save_and_archive": "Lagre og arkiver",
    "save_and_publish": "Lagre og publiser",
    "save_and_unpublish": "Lagre og avpubliser",
    "save_as_copy": "Lagre som kopi",
    "save_as_new_template": "Kopier til ny mal",
    "save_as_new_version": "Lagre som utkast"
  },
  "SectionType": {
    "article__body": "Innhold",
    "article__body_introSection": "Innhold/Scrollytell",
    "article__head": "Overskrift og ingress",
    "article__links": "Kort",
    "grid__row": "Rutenett",
    "page__grid": "Lister"
  },
  "SortDirectionLabel": "Velg sorteringsrettning",
  "SortDirections": {
    "asc": "Stigende",
    "date_asc": "Eldste først",
    "date_desc": "Nyeste først",
    "desc": "Synkende",
    "text_asc": "A-Å",
    "text_desc": "Å-A"
  },
  "SortLabel": "Velg sorteringsmetode",
  "SortOptions": {
    "created_at_asc": "Opprettet (Eldste først)",
    "created_at_desc": "Opprettet (Nyeste først)",
    "department_asc": "Avdeling (A-Å)",
    "department_desc": "Avdeling (Å-A)",
    "event_start_asc": "Arrangementsdato, stigende",
    "event_start_desc": "Arrangementsdato, synkende",
    "first_name_asc": "Fornavn (A-Å)",
    "first_name_desc": "Fornavn (Å-A)",
    "last_name_asc": "Etternavn (A-Å)",
    "last_name_desc": "Etternavn (Å-A)",
    "relevance_desc": "Relevans",
    "status_asc": "Status, stigende",
    "status_desc": "Status, synkende",
    "title_asc": "Tittel (A-Å)",
    "title_desc": "Tittel (Å-A)",
    "updated_at_asc": "Sist endret (Eldste først)",
    "updated_at_desc": "Sist endret (Nyeste først)",
    "uploaded_at_asc": "Opplastet (Eldste først)",
    "uploaded_at_desc": "Opplastet (Nyeste først)"
  },
  "SortTypeLabel": "Velg sorteringstype",
  "SortTypes": {
    "created_at": "Opprettet",
    "department": "Avdeling",
    "first_name": "Fornavn",
    "last_name": "Etternavn",
    "published_at": "Publisert",
    "title": "Tittel",
    "updated_at": "Sist endret",
    "uploaded_at": "Opplastet"
  },
  "Statistics": "Statistikk",
  "StatisticsIntro": "Standard sluttbrukerstatistikk for nettstedet fra ca August 2025. Levert av Plausible (uten bruk av informasjonskapsler).",
  "Status": {
    "archived": "Arkivert",
    "draft": "Utkast",
    "deleted": "Slettet",
    "general": "Generelt (publisert)",
    "hide_past_events": "Skjul forbigåtte",
    "imported": "Importert",
    "include_past_events": "Tidligere",
    "no_draft": "Ingen utkast",
    "not_published": "Ikke publisert",
    "published": "Publisert",
    "published_not_listed": "Publisert (ulistet)",
    "planned_publishing": "Publiseres"
  },
  "SubCategory": {
    "activity": "Aktivitet",
    "adults": "Voksne",
    "collection": "Samling",
    "concert": "Konsert",
    "conference": "Seminar/Konferanse",
    "course": "Kurs/workshop",
    "current_affairs": "Aktuelt",
    "digital": "Digital",
    "digital_event": "Digitalt arrangement",
    "earlier": "Tidligere",
    "exhibition": "Utstilling",
    "family": "Familie",
    "family_event": "Familiearrangement",
    "kids": "Barn",
    "lecture": "Foredrag/Samtale",
    "market": "Marked",
    "museum": "Arena",
    "open_position": "Ledig stilling",
    "opening": "Åpning",
    "performance": "Forestilling",
    "permanent": "Fast",
    "press": "Presse",
    "recurring_event": "Fast arrangement",
    "recurring_program": "Fast program",
    "rental": "Utleie",
    "research": "Forskning",
    "school": "Skole",
    "school_event": "Skolearrangement",
    "services": "Tjenester",
    "temporary": "Temporær",
    "touring": "Vandreutstilling",
    "tour": "Omvisning",
    "upcoming": "Kommende",
    "youth": "Ungdom"
  },
  "ViewType": {
    "grid": "Rutenettvisning",
    "list": "Listevisning"
  },
  "WeekDay": {
    "fri": "Fredag",
    "mon": "Mandag",
    "sat": "Lørdag",
    "sun": "Søndag",
    "thu": "Torsdag",
    "tue": "Tirsdag",
    "wed": "Onsdag"
  },
  "abort": "Avbryt",
  "add": "Legg til",
  "addX": "Legg til {{x}}",
  "all": "Alle",
  "appName": "Museum24 - Admin 2.0",
  "approved": "Godkjent",
  "auto": "Automatisk",
  "cancel": "Avbryt",
  "changeItemSize": "Endre størrelse på element",
  "clear": "Tøm",
  "close": "Lukk",
  "copy": "Kopier",
  "createdAt": "Opprettet",
  "cut": "Klipp ut",
  "date": "Dato",
  "decline": "Avslå",
  "declined": "Avslått",
  "default": "Auto",
  "delete": "Slett",
  "deleteFailed": "En feil oppstod ved sletting",
  "deleteSuccess": "Sletting vellykket",
  "deleteWarning": "Er du sikker på at du vil slette objekt?",
  "description": "Beskrivelse",
  "done": "Ferdig",
  "duplicate": "Dupliser",
  "error": "En feil oppstod",
  "eventData": "Arrangementsdata",
  "exit": "Gå tilbake",
  "exitUnsavedWarning": "Er du sikker på at du vil navigere bort? Du har ulagrede endringer.",
  "from": "Fra",
  "hide": "Skjul",
  "hidden": "Skjult",
  "heading_h2": "Overskrift (H2)",
  "icon": "Ikon",
  "ifOtherThanX": "Hvis annet enn \"{{x}}\"",
  "inputLabel": "Overskrift / Knappetekst",
  "internalDescription": "Intern beskrivelse",
  "language": "Språk",
  "lastEdited": "Sist endret",
  "loading": "Laster...",
  "loadingContent": "Laster innhold...",
  "menu": "Meny",
  "metadata": "Metadata",
  "moveDown": "Flytt ned",
  "moveUp": "Flytt opp",
  "name": "Navn",
  "no": "Nei",
  "noContent": "Ingen innhold",
  "none": "Ingen",
  "noneSelected": "Ingen valgt",
  "ok": "Ok",
  "others": "Andre",
  "owner": "Eier",
  "pasteName": "Lim inn {{name}}",
  "pending": "Avventende",
  "place": "Sted",
  "publishDate": "Publiseringsdato",
  "publishingStatus": "Publiseringsstatus",
  "remove": "Fjern",
  "removeX": "Fjern {{x}}",
  "removed": "Fjernet",
  "required": "Påkrevd",
  "save": "Lagre",
  "saveAndExit": "Lagre og gå tilbake",
  "saveFailed": "En feil oppstod ved lagring",
  "saveSuccess": "Lagring vellykket",
  "saved": "Lagret!",
  "screenshotInstructionErrorMessage": "Ta skjermbilde av hele vinduet, inkludert denne feilmelding, hvis du skal rapportere denne feilen.",
  "search": "Søk...",
  "searchAndKeywords": "Søk og nøkkelord",
  "searchAndCategories": "Søk og kategorier",
  "selectAll": "Velg alle",
  "selectFromList": "Velg fra listen",
  "settings": "Innstillinger",
  "show": "Vis",
  "ShowMore": "Vis mer",
  "showPortal": "Åpne nettsted",
  "showPortalDesign": "Åpne nettstedets designoversikt",
  "showTitle": "Vis tittel",
  "showingXofY": "Viser {{x}} av {{y}}",
  "siteChanged": "Byttet portal",
  "status": "Status",
  "template": "Mal",
  "title": "Tittel",
  "to": "Til",
  "tryAgain": "Prøv på nytt",
  "unselectAll": "Fjern alle valg",
  "updatedAt": "Oppdatert",
  "userIcon": {
    "alert": "Advarsel",
    "date": "Kalender",
    "download": "Last ned",
    "email": "E-post",
    "eye": "Øye",
    "info": "Informasjon",
    "person": "Person",
    "phone": "Telefon",
    "place": "Sted",
    "ticket": "Billett",
    "time": "Klokke"
  },
  "validation": {
    "genericError": "Dette feltet er ugyldig",
    "max": "Verdien må være mindre eller lik {{max}}",
    "maxLength": "For mange tegn",
    "min": "Verdien må være større eller lik {{min}}",
    "minLength": "For få tegn",
    "pattern": "Ugyldig format",
    "required": "Dette feltet er påkrevd"
  },
  "yes": "Ja"
}
